export const initialState = {
	actionPlanChangeNotes: {}
};

export default { initialState };
